import { render } from "./CopyToClipboard.vue?vue&type=template&id=1515eea4&scoped=true&lang=pug"
import script from "./CopyToClipboard.vue?vue&type=script&lang=ts"
export * from "./CopyToClipboard.vue?vue&type=script&lang=ts"

import "./CopyToClipboard.vue?vue&type=style&index=0&id=1515eea4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1515eea4"

export default script